export default function initAdditionalInsights() {
  const ANIMATION_THRESHOLD = 300;
  const windowHeight = window.innerHeight;

  const additionalInsights = document.querySelectorAll(
    ".js-additional-insights",
  );

  const isEE =
    document.body.classList.contains("is-preview") ||
    document.body.classList.contains("is-page-editor");

  if (additionalInsights && !isEE) {
    additionalInsights.forEach((component) => {
      // Give the previous sibling component aria-describedby
      // to relate it to this insights component.
      component.previousElementSibling?.setAttribute(
        "aria-describedby",
        component.id,
      );

      // Do some math to get the location of the bubble on the screen,
      // and check for when the animation should trigger.
      const componentLocation =
        component.getBoundingClientRect().top +
        document.documentElement.scrollTop;
      const animateAt = componentLocation + ANIMATION_THRESHOLD;

      const checkForAnimation = () => {
        const distanceFromBottomOfScreen = window.scrollY + windowHeight;
        if (
          (distanceFromBottomOfScreen * 0.99 < animateAt &&
            distanceFromBottomOfScreen * 1.01 > animateAt) ||
          distanceFromBottomOfScreen > animateAt
        ) {
          setTimeout(() => {
            component.classList.add("is-visible");
            component.setAttribute("tabindex", "0");
            window.removeEventListener("scroll", checkForAnimation);
          }, 750);
        }
      };

      const closestTabPanel = component.closest(".tab__panel");
      const isInHiddenTab = closestTabPanel?.hasAttribute("hidden");

      if (!isInHiddenTab) {
        window.addEventListener("scroll", checkForAnimation);
      } else {
        // If additional insight is inside of a tab panel that isn't active,
        // skip check for animation until that tab panel's trigger is clicked.
        const tabId = closestTabPanel.getAttribute("aria-labelledby");
        const tab = document.getElementById(tabId);

        tab.addEventListener("click", () => {
          checkForAnimation();
        });
      }
    });
  } else if (additionalInsights && isEE) {
    additionalInsights.forEach((component) => {
      component.classList.add("is-visible");
    });
  } else {
    return;
  }
}
